import { render, staticRenderFns } from "./CreateEditModalMedioAmbiente.vue?vue&type=template&id=44b4a114&scoped=true&"
import script from "./CreateEditModalMedioAmbiente.vue?vue&type=script&lang=ts&"
export * from "./CreateEditModalMedioAmbiente.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditModalMedioAmbiente.vue?vue&type=style&index=0&id=44b4a114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b4a114",
  null
  
)

export default component.exports